import React from 'react'
import clsx from 'clsx'
import type { TeamPresence } from '../../types/session.types'
import styles from './TeamStatusBadge.module.css'

export interface TeamStatusBadgeProps {
  presence: TeamPresence
  className?: string
}

const PRESENCE_LABELS: Record<TeamPresence, string> = {
  online: 'ONLINE',
  offline: 'OFFLINE',
  executing: 'EXECUTING',
  idle: 'IDLE',
}

export function TeamStatusBadge({ presence, className }: TeamStatusBadgeProps) {
  const label = PRESENCE_LABELS[presence] ?? presence.toUpperCase()

  return (
    <span
      className={clsx(styles.badge, styles[`badge_${presence}`], className)}
      aria-label={`Team status: ${label}`}
    >
      <span className={clsx(styles.dot, styles[`dot_${presence}`])} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </span>
  )
}
